module.exports = __webpack_public_path__ + "static/media/estilosos_masculino_roupas.c5d4593a.jpg";